import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { ArrowLeft, Eye, Person } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import { FaEye, FaRupeeSign, FaSyncAlt } from 'react-icons/fa'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

export default function DischargedStudent() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
const navigate = useNavigate()
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchAdmissionNo, setSearchAdmissionNo] = useState("");

      const fetchData = async () => {
      try {
        const userCookie = Cookies.get('user')
        const user = JSON.parse(userCookie)
        const token = user?.token

        const response = await axios.get(
          BASE_URL+'/students/inactive',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        // Safely handle the response
        const fetchedData = response.data?.students || []
        setData(fetchedData)
        setFilteredData(fetchedData)
      } catch (error) {
        console.error(
          error.response?.data?.message || 'Failed to fetch inactive students',
        )
        setData([]) // Fallback to empty array if there's an error
        setFilteredData([]);
      }
    }

  useEffect(() => {
    fetchData()
  }, [])

   useEffect(() => {
    let filtered = data;

    if (searchName.trim() !== "") {
      filtered = filtered.filter((st) =>
        st.name?.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    if (searchAdmissionNo.trim() !== "") {
      filtered = filtered.filter((st) =>
        st.admission_number?.toString().includes(searchAdmissionNo)
      );
    }

    setFilteredData(filtered);
  }, [searchName, searchAdmissionNo, data]);


  const handleActiveBack = () => {
    navigate('/AddStudent')
  }
const handleSeeFee = (studentId) => {
  const selectedStudent = data.find((st) => st.id === studentId);
  if (selectedStudent) {
    navigate("/DischargedStudentFees", {
      state: {
        student_id: selectedStudent.id,
        selectedData: selectedStudent.fees || [], // assuming 'fees' key
        studentName: selectedStudent.name,
      },
    });
  }
};

  const handleView = (id) => {
    if (!id) {
      console.error('Student ID is undefined')
      return
    }
    console.log('Navigate to : ', `/DischargedStudentsProfile/${id}`)
    navigate(`/DischargedStudentsProfile/${id}`)
  }

  const handleRefresh = () => {
    setSearchName("");
    setSearchAdmissionNo("");
    fetchData(); // reload original data
  };
  return (
    <>
      <style>
        {`
                @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important;
          }
         }
         `}
      </style>
      <div style={{ marginLeft }}>
        <div
          className="container-fluid p-0"
          style={{ marginTop: window.innerWidth < 768 ? '55px' : '-12px' }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2> Left Students</h2>
            <Button
              variant="outline-light"
              className=" responsive-btn"
              onClick={handleActiveBack}
            >
              <ArrowLeft /> Go to Active Students
            </Button>
          </div>
   <Row className="mt-4">
            <Col xs={12} md={3} className="text-start">
              <label className="fw-bold mb-2">Search by Student Name</label>
              <Form.Control
                type="text"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="Enter student name"
              />
            </Col>

            <Col xs={12} md={3} className="text-start">
              <label className="fw-bold mb-2">Search by Admission Number</label>
              <Form.Control
                type="text"
                value={searchAdmissionNo}
                onChange={(e) => setSearchAdmissionNo(e.target.value)}
                placeholder="Enter admission number"
              />
            </Col>

            <Col
              className="d-flex justify-content-end align-items-center gap-2 mt-3"
            >
              <Button variant="outline-primary" onClick={handleRefresh} title="Refresh">
                <FaSyncAlt /> Refresh
              </Button>
            </Col>
          </Row>
          <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0 mt-4">
            <Thead className="bg-dark text-white">
              <Tr>
                <Th>Admission Number</Th>
                <Th>Name</Th>
                {/* <Th>Father's Name</Th> */}
                <Th>Admission Date</Th>
                <Th>Leave Date</Th>
                <Th>Course</Th>
                {/* <Th>Class</Th>  */}
                <Th>Phone</Th>
                {/* <Th>View Fees</Th> */}
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {Array.isArray(data) && data.length > 0 ? (
                filteredData.map((st) => (
                  <Tr key={st.id}>
                    <Td>{st.admission_number}</Td>
                    <Td>{st.name}</Td>
                    {/* <Td>{st.father_name}</Td> */}
                    <Td>{st.admission_date}</Td>
                    <Td>{st.inactive_date}</Td>
                    <Td>{st.course?.name || st.course_name}</Td>
                    {/* <Td>{st.class_id || st.class_name}</Td> */}
                    <Td>{st.phone}</Td>
                    <Td>
                      <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                     <button className="btn btn-sm btn-info"
                            onClick={() => handleView(st.id)}
                            title="See Profile"
                      >
                            <Eye />
                      </button>
                    <button
                      className="btn btn-sm" 
                        style={{ backgroundColor: 'orange', color: 'white', border: 'none' }}
                      onClick={() =>
                        handleSeeFee(st.id)
                      }
                      title="See Fee"
                    >
                      <FaRupeeSign/>
                    </button>
                  </div>                      
                  </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="15" className="text-center">
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
      </div>
    </>
  )
}
